export const cloudinaryUploadPreset = "saree_upload";
export const cloudinaryCloudName = "daf5crzmf";
